import React, { useEffect, useState } from 'react'
import { fetchCandidateStatusHistories } from '../../../services/Candidate/Profile/fetchCandidateDetails';
import { renderCapitalize } from '../../../../utils/renderCapitalize';

export default function ProfileHistoryStatus({ candidateId, BeURL, showAlert }) {

    //Candidate Profile View Status History
    const [currentPage, setCurrentPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(3);
    const [totalHistory, setTotalHistory] = useState(0)
    const [totalPage, setTotalPage] = useState(0);
    const [profilesHistory, setProfileHistory] = useState(null)
    const [loading, setLoading] = useState(false)

    // Candidate Profile API
    useEffect(() => {
        if (candidateId) {
            const fetchCandidateHistory = async () => {
                await fetchCandidateStatusHistories(BeURL, candidateId, currentPage, rowsPerPage, setTotalHistory, setTotalPage, setProfileHistory, showAlert, setLoading)
            }
            fetchCandidateHistory()
        }
        // eslint-disable-next-line
    }, [candidateId, rowsPerPage, currentPage])


    return (
        <section className="my-3 bg-white p-2 rounded-xl w-full">
            {/* */}
            <div className="flex justify-between items-end"><h3 className="font-semibold text-lg mt-4">Profile History</h3>
            </div>

            <div className="my-2 min-h-[20vh] overflow-x-auto rounded-lg border border-gray-200">
                <table className="min-w-[1100px] w-full border-separate border-spacing-y-1">
                    <thead>
                        <tr>
                            <th className="sticky top-0 bg-purple-50 text-secondary-300 text-xs sm:text-sm font-medium px-2 sm:px-3 py-2 rounded-l-lg whitespace-nowrap">Client Name</th>
                            <th className="sticky top-0 bg-purple-50 text-secondary-300 text-xs sm:text-sm font-medium px-2 sm:px-3 py-2 whitespace-nowrap">Job</th>
                            <th className="sticky top-0 bg-purple-50 text-secondary-300 text-xs sm:text-sm font-medium px-2 sm:px-3 py-2 whitespace-nowrap">Submitted By</th>
                            <th className="sticky top-0 bg-purple-50 text-secondary-300 text-xs sm:text-sm font-medium px-2 sm:px-3 py-2 whitespace-nowrap">Submitted On</th>
                            <th className="sticky top-0 bg-purple-50 text-secondary-300 text-xs sm:text-sm font-medium px-2 sm:px-3 py-2 whitespace-nowrap">Type</th>
                            <th className="sticky top-0 bg-purple-50 text-secondary-300 text-xs sm:text-sm font-medium px-2 sm:px-3 py-2 whitespace-nowrap">Recent Status</th>
                            <th className="sticky top-0 bg-purple-50 text-secondary-300 text-xs sm:text-sm font-medium px-2 sm:px-3 py-2 whitespace-nowrap">Updated By</th>
                            <th className="sticky top-0 bg-purple-50 text-secondary-300 text-xs sm:text-sm font-medium px-2 sm:px-3 py-2 rounded-r-lg whitespace-nowrap">Updated On</th>
                        </tr>
                    </thead>

                    <tbody>
                        {profilesHistory && profilesHistory.length > 0 ? (
                            profilesHistory.map((pro, i) => (
                                <tr key={i}>
                                    <td className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-2 rounded-l-lg whitespace-nowrap">
                                        {renderCapitalize(pro?.client?.name)}
                                    </td>

                                    <td className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-2 whitespace-nowrap">
                                        {renderCapitalize(pro?.jobTitle) || "-"}
                                    </td>

                                    <td className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-2 whitespace-nowrap">
                                        {renderCapitalize(pro?.profileSubmittedBy?.name) || "-"}
                                    </td>

                                    <td className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-2 whitespace-nowrap">
                                        {pro?.profileSubmittedOn
                                            ? new Date(pro.profileSubmittedOn).toLocaleDateString("en-GB")
                                            : "-"}
                                    </td>

                                    <td className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-2 whitespace-nowrap">
                                        {renderCapitalize(pro?.profileSubmittedType) || "-"}
                                    </td>

                                    <td className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-2 whitespace-nowrap">
                                        {renderCapitalize(pro?.recentStatus) || "-"}
                                    </td>

                                    <td className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-2 whitespace-nowrap">
                                        {renderCapitalize(pro?.recentStatusBy?.name) || "-"}
                                    </td>

                                    <td className="bg-white text-xs sm:text-sm px-2 sm:px-3 py-2 rounded-r-lg whitespace-nowrap">
                                        {pro?.recentStatusOn
                                            ? new Date(pro.recentStatusOn).toLocaleDateString("en-GB")
                                            : "-"}
                                    </td>
                                </tr>
                            ))
                        ) : (
                            !loading && (
                                <tr>
                                    <td
                                        colSpan={8}
                                        className="bg-white text-center text-sm py-6 rounded-lg"
                                    >
                                        No Data Available!
                                    </td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>

            <div className=" flex flex-row items-center justify-between gap-5">
                <div className="flex items-center justify-center gap-2 flex-1">
                    <label className="text-xs">Page</label>
                    <select value={rowsPerPage} onChange={e => setRowsPerPage(Number(e.target.value))} className="border rounded-lg px-2 py-1 text-xs">
                        <option value={3}>3</option>
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={15}>15</option>
                    </select>
                </div>

                <div className="flex items-center justify-center gap-2 flex-1 text-xs">
                    <button
                        onClick={() => setCurrentPage((currentPage <= 1) ? 1 : currentPage - 1)}
                        disabled={currentPage <= 1}
                        className={`px-2 py-1 rounded-lg border ${currentPage <= 1 ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Prev
                    </button>

                    <span className="min-w-fit">{currentPage} of {totalPage || 1}</span>

                    <button
                        onClick={() => setCurrentPage((currentPage >= totalPage) ? totalPage : currentPage + 1)}
                        disabled={currentPage >= (totalPage || 1)}
                        className={`px-2 py-1 rounded-lg border ${currentPage >= (totalPage || 1) ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Next
                    </button>
                </div>

                <div className="text-xs text-slate-600 flex-1 text-center">
                    Total {totalHistory || 0}
                </div>
            </div>

        </section>
    )
}
